module.exports = __webpack_public_path__ + "static/media/1.57b597fe.png";